function isScrolledIntoView(elem){
    var $elem = $(elem);
    var $window = $(window);
  
    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();
  
    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();
  
    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}
$(window).scroll(function(){
$('.fade-in-left').each(function(){        
            var point = "0px", move = "-50px";
            
            if(isScrolledIntoView($(this))){        
                $(this).css({
                    'opacity':1,
                    'visibility':'visible',
                    '-webkit-transform': 'translateX(' + point + ')',
                    'transform': 'translateX(' + point + ')'                    
                });
            }
            
            else{
                $(this).css({
                    'opacity':0,
                    'visibility':'hidden',
                    '-webkit-transform': 'translateX(' + move + ')',
                    'transform': 'translateX(' + move + ')'                    
                });
            }
        });
  });